export function validateForm(form, erreurs) {
  let isValid = true;

  // Réinitialiser toutes les erreurs
  for (const key in erreurs) {
    erreurs[key] = "";
  }

  const isEmptyOrSpaces = str => !str || str.trim().length === 0;

  const isValidEmail = email => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isValidPhoneNumber = phone => {
    if (!phone) return false;
    const digits = phone.replace(/\D/g, '');
    if (digits.length === 10) {
      return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
    } else if (digits.length === 11 && digits.startsWith('1')) {
      return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits.slice(1));
    }
    return false;
  };

  function isValidDate(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    return !isNaN(date.getTime()) && date <= now;
  }

  const maxImages = 1; // Nombre maximum d'images
  const maxSizeMB = 2; // 2 Mo

  // Validation nom
  erreurs.nom = isEmptyOrSpaces(form.nom) ? "Un nom de famille est requis." : (form.nom.length > 100 ? "Le nom ne peut pas dépasser 100 caractères." : "");
  if (erreurs.nom) isValid = false;

  // Validation prénom
  erreurs.prenom = isEmptyOrSpaces(form.prenom) ? "Un prénom est requis." : (form.prenom.length > 100 ? "Le prénom ne peut pas dépasser 100 caractères." : "");
  if (erreurs.prenom) isValid = false;

  // Validation email
  erreurs.email = isEmptyOrSpaces(form.email) ? "Une adresse courriel est requise." : (!isValidEmail(form.email) ? "Une adresse courriel valide est requise." : "");
  if (erreurs.email) isValid = false;

  // Validation téléphone
  erreurs.tel = isEmptyOrSpaces(form.tel) ? "Un numéro de téléphone est requis." : (!isValidPhoneNumber(form.tel) ? "Entrez un numéro canadien valide à 10 chiffres." : "");
  if (erreurs.tel) isValid = false;

  // Validation nomAnimal
  erreurs.nomAnimal = isEmptyOrSpaces(form.nomAnimal) ? "Le nom de l'animal est requis." : (form.nomAnimal.length > 100 ? "Le nom de l'animal ne peut pas dépasser 100 caractères." : "");
  if (erreurs.nomAnimal) isValid = false;

  // Validation âge animal
  erreurs.ageAnimal = isEmptyOrSpaces(form.ageAnimal) ? "L'âge de l'animal est requis." : (!/^\d{1,2}$/.test(form.ageAnimal) ? "Entrez un âge valide (1 ou 2 chiffres)." : "");
  if (erreurs.ageAnimal) isValid = false;

  // Validation date animal perdu
  erreurs.dateAnimalPerdu = isEmptyOrSpaces(form.dateAnimalPerdu) ? "Une date est requise." : (!isValidDate(form.dateAnimalPerdu) ? "Entrez une date valide." : "");
  if (erreurs.dateAnimalPerdu) isValid = false;

  // Validation secteur perdu
  erreurs.secteurPerdu = isEmptyOrSpaces(form.secteurPerdu) ? "Un secteur est requis." : (form.secteurPerdu.length > 100 ? "Le secteur ne peut pas dépasser 100 caractères." : "");
  if (erreurs.secteurPerdu) isValid = false;

  // Validation sexe animal
  erreurs.sexeAnimal = isEmptyOrSpaces(form.sexeAnimal) ? "Veuillez sélectionner le sexe de l'animal." : "";
  if (erreurs.sexeAnimal) isValid = false;

  // Validation images
  if (!form.images || form.images.length === 0) {
    erreurs.image = "Veuillez ajouter au moins une image.";
    isValid = false;
  } else if (form.images.length > maxImages) {
    erreurs.image = `Vous ne pouvez pas téléverser plus de ${maxImages} images.`;
    isValid = false;
  } else {
    for (const file of form.images) {
      if (!file.type.startsWith('image/')) {
        erreurs.image = "Tous les fichiers doivent être des images.";
        isValid = false;
        break;
      }
      if (file.size > maxSizeMB * 1024 * 1024) {
        erreurs.image = `Chaque image doit faire moins de ${maxSizeMB} Mo.`;
        isValid = false;
        break;
      }
    }
  }

  return isValid;
}
